import oidc from "oidc-client";
import { ll } from "../../framework";
import { settings } from "../../framework/core/settings";
import { setToken } from "../../framework/core/token";
import { watchForDuplicateElementIds } from "../../framework/core/util";
import * as layout from "./resizeWindow";
import * as userPreferences from "./userPreferences/userPreferences";
import _ from "lodash";
import { usingAuth0 } from "./util/util";

export let userManager: oidc.UserManager;
export let identityServerSettings: oidc.UserManagerSettings;

export function initializeCore() {
    if (window.BroadcastChannel) {
        const ch = new BroadcastChannel("page_redirection_channel");
        ch.onmessage = (ev) => window.location.assign(ev.data);
    }

    if (localStorage.companyData) {
        var companyData = $.parseJSON(localStorage.companyData);
        settings.showDebugMessages = companyData.Settings.showDebugWarningsAndErrors;
    } else {
        settings.showDebugMessages = false;
    }

    // Base Url (required for z.dataSource)
    settings.baseUrl = window.location.origin;

    $("#initCurrentController").remove();
    $("#initLogErrorUrl").remove();

    if (!window.z.debuggerAttached) {
        settings.showDebugMessages = false;
    }

    if ($("#initInputs").children().length == 0) {
        $("#initInputs").remove();
    }

    if (settings.showDebugMessages) {
        watchForDuplicateElementIds();
    }

    // Init page resize event and call it once
    $(window).bind("resize", layout.resizeWindow);
    layout.resizeWindow();
    $.wait(750).then(layout.resizeWindow);

    // Scroll to top stuff
    $(window).on("scroll", () => {
        if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
            $("#JumpToTopButton").removeClass("hidden");
        } else {
            $("#JumpToTopButton").addClass("hidden");
        }
    });

    $("#JumpToTopButton").on("click", () => {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    });

    $("#JumpToTopButton").text(ll("JumpToTop"));

    // Remove any background-images that needed to load
    $(".background-image-load").remove();

    // fade page in
    $("body").fadeTo(750, 1);

    userPreferences.handleUserNameClick();
    $("#Logout").on("click", () => logout(undefined, "logout"));
    $("#SwitchTenant").on("click", switchTenant);

    if (!usingAuth0()) {
        userManager = new oidc.UserManager(identityServerSettings);
        autoRenewToken();
    }
}

export function getIdentityServerUrl() {
    if ($(document.head).data("ids")) {
        var urls = $(document.head).data("ids").split(" ");
        var url = urls[0];

        for (var i = 1; i < urls.length; i += 2) {
            var currentBrand = urls[i];
            var currentUrl = urls[i + 1];

            if (currentBrand == settings.brandName) {
                url = currentUrl;
            }
        }

        return url;
    }
    return null;
}

export function getUserLanguageString(): string {
    let lang = "en-US";
    if (_.has(window, "z.user.companyData")) {
        const companyData = window.z.user.companyData;
        if ("UserPreferences" in companyData) {
            const up: any[] = companyData.UserPreferences || [];
            const langUP = up.filter(userpref => (userpref.UserPreferenceNumber as string).toLowerCase() === "language");
            if (langUP.length !== 0) {
                lang = langUP[0].Value;
            }
        } else if ("Settings" in companyData) {
            const companySettings = companyData.Settings || {};
            if ("DefaultLocale" in companySettings) {
                lang = companySettings.DefaultLocale;
            }
        }
    }

    return lang;
}

const clearCookies = (): void => document.cookie
    .split(";")
    .forEach(c => document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`)
    );

export function loadIdentityServerSettings() {
    identityServerSettings = {
        authority: getIdentityServerUrl(),
        client_id: "sp10",
        redirect_uri: window.location.origin + "/Login/Redirect",
        silent_redirect_uri: window.location.origin + "/Login/Silent",
        scope: "openid profile email spprofile spapi",
        response_type: "id_token token",
        accessTokenExpiringNotificationTime: 360,
        userStore: new oidc.WebStorageStateStore({ store: localStorage })
    };
}

export function logout(wasNotAuthorized?: boolean, errorType?: string, errorDesc?: string) {
    window.removeEventListener("storage", onStorageChange);
    $(window).off("beforeunload");

    const language = getUserLanguageString();

    var idToken = localStorage.getItem("IDSIDToken");
    var loginError = localStorage.getItem("loginError");

    localStorage.clear();
    sessionStorage.clear();
    clearCookies();

    localStorage.setItem("promptLogin", "true");
    if (loginError) {
        localStorage.setItem("loginError", loginError);
    }

    if (wasLoggedIn && !usingAuth0()) {
        if (wasNotAuthorized === true) {
            var hostName = window.location.hostname;
            hostName = hostName.substring(hostName.lastIndexOf(".", hostName.lastIndexOf(".") - 1) + 1);
            document.cookie = "unauth=true;path=/;domain=" + hostName;
        }
        window.location.href =
            identityServerSettings.authority +
            "/connect/endsession?id_token_hint={1}&post_logout_redirect_uri={2}/Login/Logout"
                .format(
                    settings.brandName,
                    idToken,
                    window.location.origin
                );
    }

    let location = window.location.origin;
    if (errorType !== undefined) {
        if (errorType.toLowerCase() === "logout") {
            localStorage.setItem("language", language);
            location += "/Logout"
        } else if (errorType !== undefined) {
            location += `/Login/#error=${errorType}`;
            if (errorDesc !== undefined) {
                location += `&error_description=${errorDesc}`;
            }
        }
    }

    window.location.href = location;
}

export const switchTenant = () =>
{
    window.location.assign("/SelectTenant/");
}

export function autoRenewToken() {
    // accessTokenExpring event will fire automatically once we have reached the notification time.
    // Except, if we are already past the notification time, it does not fire automatically.
    // But if we call getUser() this causes accessTokenExpiring event to fire if we are past the notication time.
    // Therefore, call getUser() and subscribe to the accessTokenExpiring event once that promise is resolved.
    userManager.getUser().then(function (user) {
        if (user.expired) {
            logout(true);
            return;
        }

        userManager.events.addAccessTokenExpiring(function () {
            if (localStorage.renewingToken) {
                // Multiple tabs will try to renew the token at the same time. Only let one tab renew the token.
                return;
            }
            localStorage.renewingToken = true;

            console.log("Renewing token...");

            userManager.signinSilent({})
                .then(function (usr) {
                    console.log("Token renewed!");

                    updateUserSilent(usr);

                    localStorage.removeItem("renewingToken");
                })
                .catch(function (err) {
                    console.log("Error renewing token!");
                    console.log(err);

                    localStorage.removeItem("renewingToken");
                });
        });
    });
}

export function updateUser(user) {
    localStorage.setItem("IDSBearer", user.access_token);
    localStorage.setItem("IDSIDToken", user.id_token);

    var profile = user.profile;

    var loginData = {
        Token: profile.session,
        UserId: parseInt(profile.uid, 10),
        FullName: profile.fname + " " + profile.lname,
        FirstName: profile.fname,
        LastName: profile.lname,
        UserName: profile.email,
        Companies: [
            {
                Id: parseInt(profile.cid, 10),
                CompanyName: profile.cname,
                CompanyVersionNumber: profile.cver,
                IsMobile: false
            }
        ],
        SelectedCompanyId: parseInt(profile.cid, 10)
    };

    localStorage.loginData = JSON.stringify(loginData);
    localStorage.token = profile.session;
    setToken(localStorage.token);

    localStorage.companyVersion = profile.cver;
}

const updateUserSilent = (user: oidc.User): void => {
    const lsCompanyId = localStorage.getItem("Company-Id");
    const companyId = parseInt(lsCompanyId, 10);

    if (isNaN(companyId)) {
        return updateUser(user);
    }

    const profile = user.profile;
    const lsCompanyData = localStorage.getItem("companyData");
    const companyData = JSON.parse(lsCompanyData);

    localStorage.setItem("IDSBearer", user.access_token);
    localStorage.setItem("IDSIDToken", user.id_token);
    const loginData = {
        Token: profile.session,
        UserId: parseInt(profile.uid, 10),
        FullName: `${profile.fname} ${profile.lname}`,
        FirstName: profile.fname,
        LastName: profile.lname,
        UserName: profile.email,
        Companies: [
            {
                Id: companyId,
                CompanyName: companyData.CompanyName,
                CompanyVersionNumber: companyData.CompanyVersionNumber,
                IsMobile: false
            }
        ],
        SelectedCompanyId: companyId
    }

    localStorage.setItem("loginData", JSON.stringify(loginData));
    localStorage.setItem("token", profile.session);
    setToken(localStorage.token);

    localStorage.setItem("companyVersion", companyData.CompanyVersionNumber);
}

var wasLoggedIn = false;
if (localStorage.IDSIDToken) {
    wasLoggedIn = true;
}

var onStorageChange = function () {
    console.log("storage changed!");
    setToken(localStorage.token);

    if (localStorage.IDSIDToken) {
        wasLoggedIn = true;
    }

    if (!localStorage.IDSIDToken && wasLoggedIn) {
        logout();
    }
};

export function synchronizeAuthentication() {
    window.addEventListener("storage", onStorageChange, false);
}
